import React from 'react';
import './CarCard.css'
import Btn from './Btn';

const CarCard = (props) => {
    return ( 
        <div className='CarCard'>
            <div className='CarImgContainer'>
                <img className='CarImg' src={props.CarImg} alt="" />
            </div>

            <div className='CarText'>
                <p className='CarName'>
                    {props.CarName}
                </p>
                <p className='CarId'>
                    {'ID: ' + props.CarId}
                </p>

                <div className='CarStats'>
                    <div className='CarStatCard'>
                        <p className='StatName'>Range</p>
                        <p className='StatNum'>{props.CarRange + ' KM'}</p>
                    </div>
                    <div className='CarStatCard'>
                        <p className='StatName'>Horsepower</p>
                        <p className='StatNum'>{props.CarHp + ' HP'}</p>
                    </div>
                    <div className='CarStatCard'>
                        <p className='StatName'>Top Speed</p>
                        <p className='StatNum'>{props.CarSpeed + ' km/h'}</p>
                    </div>
                </div>

                <div className='CarCardBtns'>
                    <Btn BtnText='Edit Vehicle' BtnStyle='EditBtn2' onClick={props.editFunc}/>
                    <Btn BtnText='Delete' BtnStyle='DeleteBtn' onClick={props.deleteFunc}/>
                </div>
            </div>
        </div>
     );
}
 
export default CarCard;